document.addEventListener("DOMContentLoaded", function () {
  const containers = Array.from(
    document.querySelectorAll(".read-more-container")
  );

  if (!containers.length) return;

  function open(container) {
    const content = container.querySelector(".read-more-content");
    const toggle = container.querySelector(".read-toggle");

    content.style.display = "block";
    const height = content.scrollHeight + "px";
    content.style.height = "0px";

    requestAnimationFrame(() => {
      content.style.height = height;
      content.classList.add("is-open");
      container.classList.add("is-open");
    });

    toggle.setAttribute("aria-expanded", "true");
    content.setAttribute("aria-hidden", "false");
  }

  function close(container) {
    const content = container.querySelector(".read-more-content");
    const toggle = container.querySelector(".read-toggle");

    if (!container.classList.contains("is-open")) return;

    const height = content.scrollHeight + "px";
    content.style.height = height;

    requestAnimationFrame(() => {
      content.style.height = "0px";
      content.classList.remove("is-open");
      container.classList.remove("is-open");
    });

    content.addEventListener("transitionend", function handler() {
      content.style.display = "none";
      content.removeEventListener("transitionend", handler);
    });

    toggle.setAttribute("aria-expanded", "false");
    content.setAttribute("aria-hidden", "true");
  }

  function toggle(container) {
    const isOpen = container.classList.contains("is-open");

    // Accordion behavior: close all others
    containers.forEach(other => {
      if (other !== container) close(other);
    });

    isOpen ? close(container) : open(container);
  }

  containers.forEach(container => {
    const toggleBtn = container.querySelector(".read-toggle");
    const title = container.querySelector(".read-more-title");

    toggleBtn.addEventListener("click", e => {
      e.preventDefault();
      toggle(container);
    });

    title.addEventListener("click", () => toggle(container));

    title.addEventListener("keydown", e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggle(container);
      }
    });
  });
});